import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ModuleAccessService } from '../services/module-access.service';
import type { AppModuleKey } from '../constants/app-modules';

/**
 * UX guard: hides routes when modules are disabled. Backend remains authoritative.
 */
export function moduleGuard(...required: AppModuleKey[]): CanActivateFn {
  return async (_route, _state) => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const modules = inject(ModuleAccessService);

    await auth.waitForInitialization();
    if (auth.isSuperAdmin()) {
      return true;
    }

    await modules.ensureReady();
    if (modules.hasAllModules(required)) {
      return true;
    }

    await router.navigate(['/home']);
    return false;
  };
}
